var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1874 847L1874 875",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1874.5,
    cy: 842.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1869.99 842.19C1869.99 838.283 1873.29 835.117 1877.36 835.117C1877.94 835.117 1878.51 835.184 1879.06 835.308C1877.74 834.48 1876.19 834 1874.52 834C1869.81 834 1866 837.806 1866 842.5C1866 847.194 1869.81 851 1874.52 851C1876.81 851 1878.89 850.093 1880.43 848.62C1879.49 849.032 1878.45 849.263 1877.36 849.263C1873.29 849.263 1869.99 846.096 1869.99 842.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1883.4 841.6L1883.37 839.146L1881.54 840.719L1879.3 840.056L1880.11 842.337L1878.77 844.381L1881.1 844.218L1882.5 846.144L1883.13 843.763L1885.34 842.909L1883.4 841.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch4);
export default __webpack_public_path__ + "static/media/church_4.e5ef4bb951573e3b1572166f0c958a88.svg";
export { ForwardRef as ReactComponent };